import { useEffect } from 'react';
import { APP_NAME, upsertMetaTag } from '@/utils/pageMeta';

/**
 * Overrides the route-level document title once page-specific context (e.g. a site title) is known.
 * Runs after the route change effect in App.tsx, so this wins whenever `detail` is set.
 */
export function usePageTitle(detail: string | null | undefined, fallback: string): void {
  useEffect(() => {
    const title = `${detail?.trim() || fallback} | ${APP_NAME}`;
    document.title = title;
    upsertMetaTag('meta[property="og:title"]', 'property', 'og:title', title);
    upsertMetaTag('meta[name="twitter:title"]', 'name', 'twitter:title', title);
  }, [detail, fallback]);
}
